// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode';
import $ from 'jquery';

// DOM tag element
const bodyTag = 'body';
const idToken = 'idToken';
// Impersonated user id
const shadowId = 'shadowId';

// Returns an object of the JWT data
const decodeJWTIdToken = () => {
    const token = $(bodyTag).data(idToken);

    if (!token) {
        return null;
    }

    return jwt_decode(atob(token));
};

// Returns the id token of the user
const getIdToken = () => {
    const token = $(bodyTag).data(idToken);

    if (token == null) {
        return null;
    }

    return atob(token);
};

// Returns just the user cognito user's id
const getUserId = () => {
    const decodedToken = decodeJWTIdToken();

    if (decodedToken?.sub == null) {
        return null;
    }

    return decodedToken.sub;
};

const getImpersonatedUserId = () => {
    const userId = $(bodyTag).data(shadowId);

    if (userId == null) {
        return null;
    }

    return atob(userId);
};

const getUserEmail = () => {
    const decodedToken = decodeJWTIdToken();

    if (decodedToken?.email == null) {
        return null;
    }

    return decodedToken.email;
};

const getMaskedUserEmail = () => {
    const email = getUserEmail();

    if (email == null) {
        return null;
    }

    const splitEmail = email.split('.');
    let encodeEmail = '';

    encodeEmail += email.match(/^[a-zA-Z]?/) + "***";
    encodeEmail += email.match(/@.?/)
    encodeEmail += '***.' + splitEmail[splitEmail.length - 1];

    return encodeEmail;
}

export { getUserId, getIdToken, getImpersonatedUserId, getUserEmail, getMaskedUserEmail };
